import useAPIClient from "../../core/services/API/hooks/useAPIClient";
import useCacheQuery, {CacheQueryOpts, CacheQueryOutput} from "../../core/services/query/hooks/useCacheQuery";
import {SavedCard} from "../types/PaymentCard";

export default function usePaymentCardGet(
    uuid: string | null | undefined,
    options?: CacheQueryOpts<SavedCard>
): CacheQueryOutput<SavedCard> {
    const client = useAPIClient();

    return useCacheQuery<SavedCard>(
        ["payment-card", uuid],
        () => {
            if (!uuid) throw new Error("No payment card UUID provided");
            return client.get<SavedCard>(`payment_cards/${uuid}`);
        },
        {
            execute: !!uuid,
            ...options,
        }
    );
}

